const SocialIcons = () => {
    const styles = {
      icon: {
        textDecoration: "none",
        fontSize: "22px",
        padding: "10px",
        transition: "0.2s ease-in",
      },
    };
  
    return (
      <div className="socialIcons" style={styles.socialIcons}>
          <a className="icon" style={styles.icon} href="https://dev-to-mm.netlify.app" target="_blank">
          <i className="fa-solid fa-paper-plane" aria-hidden="true" title="Minn Thu Kyaw' Personal Profile"></i>
        </a>
        <a className="icon" style={styles.icon} href="https://github.com/thukyaw11" target="_blank">
          <i className="fa-brands fa-github" aria-hidden="true" title="Minn Thu Kyaw' GitHub Profile"></i>
        </a>
      
        {/* <a className="icon" style={styles.icon} href="https://www.instagram.com/michael.yeates/">
          <i className="fa-brands fa-instagram" aria-hidden="true" title="Michael Yeates' Instagram Profile"></i>
        </a> */}
        <a className="icon" style={styles.icon} href="https://www.facebook.com/daw.n.khaing.5836/" target="_blank">
          <i className="fa-brands fa-facebook" aria-hidden="true" title="Minn Thu Kyaw' Twitter Profile"></i>
        </a>
      </div>
    );
  };
  
  export default SocialIcons;